import { render } from "./ImageSlides.vue?vue&type=template&id=1deefb98&scoped=true&lang=pug"
import script from "./ImageSlides.vue?vue&type=script&lang=js"
export * from "./ImageSlides.vue?vue&type=script&lang=js"

import "./ImageSlides.vue?vue&type=style&index=0&id=1deefb98&lang=scss&scoped=true"

import exportComponent from "/Applications/DEV/kevin/GIT/monafoto.ee/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1deefb98"]])

export default __exports__